<template>
    <div class="container">
        <img class="background-image" :src="preText + bgImg" alt="">
        <div class="big-img-link" @click="clickBigImgLink"></div>
        <div class="item-list">
            <div class="item" v-for="(item, index) in itemList" :key="index">
                <img :src="preText + item.img_item" alt="" @click="clickItem(item)">
            </div>
        </div>
    </div>
  </template>
  
  <script>
  import { isPortraitFun } from "@/utils/utils.js";
  
  export default {
    props: {
      itemList: {
        type: Array,
        required: true,
        default: () => []
      },
      bgImg: {
        type: String,
        required: true,
        default: ''
      },
      bigImgLink: {
        type: String,
        required: true,
        default: ''
      }
    },
    data() {
      return {
        isPortrait: isPortraitFun(),
        preText:'https://www.kia.cn',
      };
    },
    mounted: function () {
      if (!window.location.href.includes("https://www.kia.cn")) {
        this.preText = 'https://uat.kia.cn'
      }else{
        this.preText = 'https://www.kia.cn'
      }
    },
    methods: {
      clickBigImgLink: function () {
        window.open(this.bigImgLink, '_blank');
      },
      clickItem: function (item) {
        window.open(item.link, '_blank');
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @media (max-width: 767px) {
    .container {
        height: calc(1189 / 750 * 100vw);
        position: relative;
        width: 100%;
        user-select: none;
        z-index: 0;
    }
    .background-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .big-img-link {
        position: absolute;
        top: calc(422 / 750 * 100vw);
        left: calc(32 / 750 * 100vw);
        width: calc(686 / 750 * 100vw);
        height: calc(436 / 750 * 100vw);
        background-color: transparent;
    }
    .item-list {
        position: absolute;
        top: calc(879 / 750 * 100vw);
        left: calc(32 / 750 * 100vw);
        width: calc(718 / 750 * 100vw);
        height: calc(239.34 / 750 * 100vw);
        display: flex;
        flex-wrap: nowrap;
        gap: calc(10 / 750 * 100vw);
        overflow-x: auto;
        overflow-y: hidden;
        background-color: transparent;
        padding-right: calc(32 / 750 * 100vw);
    }
    .item {
        flex: 0 0 auto;
        width: calc(239.34 / 750 * 100vw);
        height: calc(239.34 / 750 * 100vw);
        object-fit: cover;
        border-radius: calc(11.97 / 750 * 100vw);
        overflow: hidden;
    }
  }
  </style>